/**
 * Sidebar + route gate for Your Stuff.
 * Requires has_employee and your_stuff_permission (either alone is not enough).
 */
export function isYourStuffAllowed(accessPermission) {
  if (!accessPermission) {
    return false;
  }
  if (accessPermission.has_employee !== true) {
    return false;
  }
  return (
    accessPermission.yourstuff_permission === true ||
    accessPermission.your_stuff_permission === true
  );
}
